import React from "react";
import {each, isArray, isBoolean} from "underscore";
import {ActionCell, CustomActionCell} from "./ActionCells";
import {getIconForAction} from "./actionIcons";

export const actionColumn = () => ({
  align: "center",
  disableClickEventBubbling: true,
  disableColumnMenu: true,
  disableExport: true,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  cellClassName: () => "brxActionCell",
});

const getActionLabel = (action, {isArchived, isEnabled, isObligationList}) => {
  if (action === "del") {
    return "Delete";
  }
  if (action === "archive") {
    return isArchived ? "Unarchive" : "Archive";
  }
  if (action === "enablement") {
    if (isObligationList) {
      return isEnabled ? "Set to Draft" : "Set to Active";
    }
    return isEnabled ? "Disable" : "Enable";
  }
  return `${action[0].toUpperCase()}${action.slice(1)}`;
};

export const getTableActions = (params) => {
  if (!params?.showActions) {
    return [];
  }

  const actionsForTable = [];
  const isArchived = params?.isArchived;
  const isEnabled = params?.isEnabled;
  const isDuplicateLoading = params?.isDuplicateLoading;
  const isObligationList = !!params?.isObligationList;

  each(["view", "edit", "duplicate", "enablement", "archive", "del"], (actionType) => {
    if (params?.[actionType]) {
      if (actionType === "archive" && !isBoolean(isArchived)) {
        return;
      }
      if (actionType === "enablement" && !isBoolean(isEnabled)) {
        return;
      }

      const label = getActionLabel(actionType, {isArchived, isEnabled, isObligationList});
      const icon = getIconForAction(actionType, {isArchived, isDuplicateLoading, isEnabled});
      if (!icon) {
        return;
      }

      const onClick =
        actionType === "duplicate" && isDuplicateLoading ? undefined : params[actionType];

      actionsForTable.push(
        <ActionCell
          key={actionType}
          actionType={actionType}
          label={label}
          icon={icon}
          onClick={onClick}
        />,
      );
    }
  });

  each(["custom", "conditional"], (specialActionType) => {
    if (!isArray(params?.[specialActionType])) {
      return;
    }

    each(params[specialActionType], (specialAction, index) => {
      if (specialActionType === "conditional" && !specialAction.isAuthorized) {
        return;
      }

      actionsForTable.push(
        <CustomActionCell
          key={`${specialActionType}-${specialAction.label || index}`}
          label={specialAction.label}
          icon={specialAction.icon}
          onClick={specialAction.onClick}
          disabled={specialAction.disabled}
        />,
      );
    });
  });

  return actionsForTable;
};
